export class Module {
  id!: number;
  name!: string;
  price!: number;
  isDisabled?: boolean;
}
